// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jYK8e","stars":"styles_stars__KYyqf","title":"styles_title__iSt7y","subtitle":"styles_subtitle__4KwHV"};